import React, { useEffect, useState } from "react";
import { Table } from "../../components";
import { PageHeader, Spin, Input } from "antd";
import { getUrl, requests } from "../../globals/requests";
import { Container, TableContainer } from "../../globals/styles";
import { Button } from "../../components";
import { helpers } from "../../utils";

import { Modal } from "antd";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
];

function AdminData({ organisation }) {
  const [value, setValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [adminsData, setAdminsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    handleInviteAdmin(organisation?._id, value);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  async function getContracts() {
    try {
      setLoading(true);
      const orgId = organisation._id;
      const url = `${getUrl("organisations")}/adminPanel/${orgId}`;
      const response = await requests.getWithAuth(url);
      const data = response.data;

      const admins = [];
      setLoading(false);

      data?.admins?.forEach((eachContract) => {
        const { _id, email, first_name, last_name } = eachContract;

        admins.push({
          name: `${first_name || " - "}  ${last_name || " - "}`,
          email,
          status: _id?.length > 0 ? "Active" : "Inactive",
        });
      });
      setAdminsData(admins.reverse());
    } catch (e) {
      console.log(e);
      setLoading(false);
      helpers.displayMessage(e);
    }
  }

  const refreshAdmins = async () => {
    await getContracts();
  };

  async function handleInviteAdmin(id, email) {
    try {
      const url = `${getUrl("organisations")}/inviteAdmin/${id}`;
      const data = { email };
      await requests.postWithAuth(url, data);
      helpers.successModal("Admin has been invited!!!");

      refreshAdmins();
    } catch (e) {
      helpers.displayMessage(e);
    }
  }

  useEffect(() => {
    if (organisation && organisation._id) {
      getContracts();
    }
  }, [organisation]);

  if (loading) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Loading Admins..."></Spin>
      </div>
    );
  }

  return (
    <Container>
      <hr />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <PageHeader className="site-page-header" title="Admins" subTitle="" />
        <Button onClick={showModal} title={"Invite"} type="primary" />
      </div>

      <TableContainer>
        <Table columns={columns} dataSource={adminsData} />
      </TableContainer>

      <Modal
        title="Invite Admin"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Input
          name="email"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Email"
        />
      </Modal>
    </Container>
  );
}

export default AdminData;
